import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Section } from '../components/ui/Section';
import { Card } from '../components/ui/Card';
import { ContactCTA } from '../components/sections/ContactCTA';
import { reviews } from '../data/mock';

export const ReviewsPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <div className="bg-primary-dark py-24 text-center text-white mt-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Recenzije</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Šta naši klijenti kažu o nama i našim uslugama.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        <Section>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review) => (
              <Card key={review.id} className="p-8 relative bg-white border-none shadow-lg hover:shadow-xl transition-shadow">
                <Quote className="absolute top-6 right-6 text-primary/10" size={48} />
                
                <div className="flex gap-1 mb-4 text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={18} fill="currentColor" />
                  ))}
                </div>

                <p className="text-gray-600 mb-6 italic leading-relaxed min-h-[80px]">
                  "{review.comment}"
                </p>

                <div className="flex items-center gap-4 border-t border-gray-100 pt-4">
                  <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center font-bold text-xl">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{review.name}</div>
                    <div className="text-sm text-gray-500">{review.date}</div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </Section>
        
        <ContactCTA />
      </main>

      <Footer />
    </div>
  );
};
